/* eslint-disable no-restricted-imports */

import * as React from "react";
import LinearProgress from "material-ui/LinearProgress";
import CircularProgress from "material-ui/CircularProgress";
import { busyIndicatorClass } from "uiTestClasses";
import { withTheme } from "components/Theme";
const styles = require("./style.less");

interface BusyIndicatorProps {
    show: boolean;
    inline?: boolean;
}

const BusyIndicator: React.FC<BusyIndicatorProps> = (props) =>
    withTheme((theme) => {
        if (props.inline) {
            return (
                <>
                    {props.show && (
                        <span role="progressbar" className={`${busyIndicatorClass} ${styles.circularBusyIndicator}`}>
                            <CircularProgress mode="indeterminate" color={theme.primaryLight} size={22} thickness={2} />
                        </span>
                    )}
                </>
            );
        } else {
            return props.show ? (
                // Giving this a distinct key ensures that when we are no longer busy, the progressbar HTML element gets removed (rather than mutated into something else)
                // This means we are able to more reliably detect if it gets removed in tests
                <div role="progressbar" key="progressbar" className={`${busyIndicatorClass} ${styles.busyIndicator}`}>
                    <LinearProgress mode="indeterminate" color={theme.loadingIndicator} />
                </div>
            ) : (
                <div key="hidden-spacer" className={styles.busyIndicatorHiddenSpacer} />
            );
        }
    });

BusyIndicator.displayName = "BusyIndicator";

export default BusyIndicator;
